exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".listFilmBoxesContainer\n{\n    width: 100%;\n    height: 25vh;\n    position: relative;\n}\n\n.listFilmBoxesBox\n{\n    width: 19%;\n    height: 100%;\n    margin-right: 1%;\n    background-position: center;\n    background-size: cover;\n    background-repeat: no-repeat;\n    float: left;\n    position: relative;\n}\n\n.listFilmBoxesBoxText\n{\n    background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0.9)), to(rgba(0, 0, 0, 0.9)));\n    background-image: linear-gradient(rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.9));\n    color: rgb(255,255,255);\n    font-size: 14pt;\n    text-align: center;\n    width: 100%;\n    font-family: serif;\n    position: absolute;\n    bottom: 0px; \n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ppeters/filmCritClient/src/app/components/listPageContentBoxes/listPageContentBoxes.component.css
// module id = ../../../../../src/app/components/listPageContentBoxes/listPageContentBoxes.component.css
// module chunks = main